import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiInputLabel']
>['styleOverrides'] = {
  root: ({ theme, ownerState }) => ({
    fontSize:
      ownerState.size === 'small'
        ? theme.typography.body2.fontSize
        : theme.typography.body1.fontSize,
  }),
};

const MuiInputLabel: Components<CssVarsTheme>['MuiInputLabel'] = {
  styleOverrides,
};

export default MuiInputLabel;
